import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Box, useColorModeValue } from "@chakra-ui/react";

export default function AuthLayout() {
  const authBg = useColorModeValue("white", "navy.900");
  
  // Eğer kullanıcı giriş yapmışsa admin paneline yönlendir
  // Token artık httpOnly cookie'de, sadece business bilgilerini kontrol et
  const business = localStorage.getItem("business");
  const restaurantId = localStorage.getItem("restaurantId");
  if (business && restaurantId) {
    return <Navigate to="/admin/panel" replace />;
  }

  return (
    <Box 
      bg={authBg}
      minH="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      position="relative"
    >
      <Outlet />
    </Box>
  );
}